// frontend/src/hooks/useScoreTickHaptic.ts
//
// Buzz when YOUR live score ticks UP - the physical half of the score
// animation (your player just did something). Fires at most once per data
// refresh (scores arrive on 10-30s polls), only for increases, only while
// the app is visible, and never on mount or week/contest navigation (the
// first value seen is the baseline, not a tick).
import { useEffect, useRef } from 'react';
import { hapticSuccess } from '@/services/haptics';

export function useScoreTickHaptic(value: number, enabled: boolean = true): void {
  const prevRef = useRef<number | null>(null);

  useEffect(() => {
    if (!enabled) {
      prevRef.current = null;
      return;
    }
    const prev = prevRef.current;
    prevRef.current = value;
    if (prev === null) return; // baseline, not a tick
    if (value > prev + 0.001 && document.visibilityState === 'visible') {
      hapticSuccess();
    }
  }, [value, enabled]);
}
